@if (entries.length > 0) {
  <div class="mb-gen-fab" [class.expanded]="expanded">

    <!-- Expanded stack -->
    @if (expanded) {
      <div class="mb-gen-stack">
        @for (entry of entries; track entry.imageId) {
          <div class="mb-gen-entry" [class.completed]="entry.status === 'completed'">
            <div class="mb-gen-entry-icon">
              @if (entry.status === 'processing') {
                <span class="mb-gen-dot-pulse"><span></span><span></span><span></span></span>
              } @else {
                <span class="mb-gen-check">✓</span>
              }
            </div>
            <div class="mb-gen-entry-info">
              <span class="mb-gen-entity-name">{{ entry.entityName || 'Visual Element' }}</span>
              <span class="mb-gen-status">{{ entry.status === 'processing' ? 'Generating…' : 'Looks Ready' }}</span>
            </div>
            @if (entry.status === 'completed') {
              <button class="mb-gen-view-btn" (click)="viewResult(entry)">View</button>
              <button class="mb-gen-dismiss-btn" (click)="dismiss(entry, $event)" title="Dismiss">✕</button>
            }
          </div>
        }
      </div>
    }

    <!-- Collapsed pill toggle -->
    <button
      class="mb-gen-pill"
      [class.has-complete]="isAnyComplete"
      (click)="expanded = !expanded"
    >
      @if (processingCount > 0 && !isAnyComplete) {
        <span class="mb-gen-pill-dots"><span></span><span></span><span></span></span>
      } @else if (isAnyComplete) {
        <span class="mb-gen-pill-check">✓</span>
      }
      <span class="mb-gen-pill-label">{{ summaryLabel }}</span>
      <span class="mb-gen-pill-chevron">{{ expanded ? '▾' : '▸' }}</span>
    </button>

  </div>
}
